<template>
    <ui-modal :title="modalTitle" ref="modal">
        <div class="columns">
            <div class="column is-12">
                <div class="columns">
                    <div class="column is-4">
                        <label class="label">First Name *</label>

                        <p class="control">
                            <input
                                name="first_name"
                                class="input is-large"
                                type="text"
                                v-model="form.first_name"
                                required
                            >
                            <span
                                v-if="form.errors.has('first_name')"
                                class="help is-danger"
                            >{{ form.errors.first('first_name') }}</span>
                        </p>
                    </div>
                    <div class="column is-4">
                        <label class="label">Last Name *</label>
                        <p class="control">
                            <input
                                name="last_name"
                                class="input is-large"
                                type="text"
                                v-model="form.last_name"
                                required
                            >
                            <span
                                v-if="form.errors.has('last_name')"
                                class="help is-danger"
                            >{{ form.errors.first('last_name') }}</span>
                        </p>
                    </div>
                    <div class="column is-4">
                        <label class="label">Title *</label>
                        <p class="control">
                            <input
                                name="title"
                                class="input is-large"
                                type="text"
                                v-model="form.title"
                                required
                            >
                            <span
                                v-if="form.errors.has('title')"
                                class="help is-danger"
                            >{{ form.errors.first('title') }}</span>
                        </p>
                    </div>
                </div>

                <div class="columns">
                    <div class="column is-4">
                        <label class="label">Email</label>
                        <p class="control">
                            <input
                                name="email"
                                class="input is-large"
                                type="email"
                                v-model="form.email"
                            >
                            <span
                                v-if="form.errors.has('email')"
                                class="help is-danger"
                            >{{ form.errors.first('email') }}</span>
                        </p>
                    </div>

                    <div class="column is-3">
                        <label class="label">Phone</label>
                        <p class="control">
                            <input
                                name="phone"
                                class="placeholder-gray-400 input is-large"
                                placeholder="555-999-6543"
                                type="tel"
                                v-model="form.phone"
                            >
                            <span
                                v-if="form.errors.has('phone')"
                                class="help is-danger"
                            >{{ form.errors.first('phone') }}</span>
                        </p>
                    </div>

                    <div class="column is-1">
                        <label class="label">Ext</label>
                        <p class="control">
                            <input
                                name="phone_ext"
                                class="input is-large"
                                type="text"
                                v-model="form.phone_ext"
                            >
                            <span
                                v-if="form.errors.has('phone_ext')"
                                class="help is-danger"
                            >{{ form.errors.first('phone_ext') }}</span>
                        </p>
                    </div>

                    <div class="column is-3">
                        <label class="label">Phone 2</label>
                        <p class="control">
                            <input
                                name="phone_2"
                                class="input is-large"
                                type="text"
                                v-model="form.phone_2"
                            >
                            <span
                                v-if="form.errors.has('phone_2')"
                                class="help is-danger"
                            >{{ form.errors.first('phone_2') }}</span>
                        </p>
                    </div>

                    <div class="column is-1">
                        <label class="label">Ext</label>
                        <p class="control">
                            <input
                                name="phone_2_ext"
                                class="input is-large"
                                type="text"
                                v-model="form.phone_2_ext"
                            >
                            <span
                                v-if="form.errors.has('phone_2_ext')"
                                class="help is-danger"
                            >{{ form.errors.first('phone_2_ext') }}</span>
                        </p>
                    </div>
                </div>

                <div class="columns">
                    <div class="column is-8">
                        <label class="label">Notes</label>
                        <p class="control">
                            <trumbowyg
                                v-model="form.notes"
                                :config="config"
                                class="form-control"
                                name="notes"
                            ></trumbowyg>

                            <span
                                v-if="form.errors.has('notes')"
                                class="help is-danger"
                            >{{ form.errors.first('notes') }}</span>
                        </p>
                    </div>
                    <div class="column is-4">
                        <div class="columns is-multiline">
                            <div class="column is-12">
                                <label class="label">Type *</label>
                                <p class="control">
                                    <span class="select is-large">
                                        <select
                                            name="type"
                                            v-model="form.type"
                                            required
                                        >
                                            <option
                                                v-for="(name, type) in contactTypes"
                                                :value="type"
                                                :key="type"
                                                v-text="name"
                                            ></option>
                                        </select>
                                    </span>
                                </p>
                            </div>
                            <div class="column is-12">
                                <p class="control">
                                    <label class="checkbox">
                                        <input
                                            id="primary"
                                            name="primary"
                                            type="checkbox"
                                            value="true"
                                            v-model="form.primary"
                                        >
                                        <strong>{{ trans('app.primary').titleCase() }}</strong>
                                    </label>
                                </p>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="columns">
                    <div class="column is-6">
                        <label class="label">Profile Photo <small>(Image must be .jpg or .png. Max file size 2mb)</small></label>
                        <p class="control has-icon has-icon-right">
                            <input
                                name="avatar"
                                class="input"
                                ref="file"
                                type="file"
                                @change="addFile($event)"
                            >
                            <span
                                v-if="form.errors.has('avatar')"
                                class="help is-danger"
                            >{{ form.errors.first('avatar') }}</span>
                        </p>
                    </div>
                </div>
            </div>
        </div>

        <footer slot="footer">
            <button
                class="button is-medium mrs"
                type="button"
                @click="closeModal"
                :disabled="loading"
            >{{ trans('app.cancel').titleCase() }}</button>

            <button
                type="button"
                class="button is-success is-medium mrs"
                :disabled="loading"
                @click="submit"
            >
                <span>{{ trans('app.save').titleCase() }}</span>

                <div
                    v-if="loading"
                    class="centered loader is-medium"
                ></div>
            </button>
        </footer>
    </ui-modal>
</template>

<script>
import Trumbowyg from 'vue-trumbowyg';
import 'trumbowyg/dist/ui/trumbowyg.css';
import Form from 'form-backend-validation';

export default {

    components: {
        Trumbowyg,
    },
    props: {
        contactTypes: {
            type: Object,
            required: true,
        },
    },

    data () {
        return {
            contact: null,
            loading: false,
            form: new Form({
                first_name: null,
                last_name: null,
                title: null,
                email: null,
                phone: null,
                phone_ext: null,
                phone_2: null,
                phone_2_ext: null,
                contactable_type: null,
                contactable_id: null,
                notes: '',
                type: 'accounts_receivable',
                primary: false,
                photo: null,
                _method: 'POST',
            }),
            config: {
                resetCss: true,
                autogrow: false,
                btns: [
                    ['formatting'],
                    ['strong', 'em', 'del'],
                    ['unorderedList', 'orderedList'],
                    ['justifyLeft', 'justifyCenter', 'justifyRight', 'justifyFull'],
                    ['link'],
                    ['removeformat'],
                    ['fullscreen'],
                    ['viewHTML'],
                ],
            },
        };
    },

    computed: {
        isEdit () {
            return ! _.isNull(this.contact);
        },

        modalTitle () {
            let lang_key = this.isEdit ? 'app.edit_this' : 'app.add_new_this';

            return this.trans(lang_key, {this: this.transChoice('app.contact', 1)}).titleCase();
        },

        actionRoute () {
            return this.isEdit
                ? this.route('contacts.update', {contact: this.contact.id})
                : this.route('contacts.store');
        },
    },

    listeners: {
        'open-contact-add-modal' (contactable_type, contactable_id) {
            this.form.contactable_type = contactable_type;
            this.form.contactable_id = contactable_id;

            this.showModal();
        },

        'open-contact-edit-modal' (contact = null) {
            if (! _.isNull(contact)) {
                this.setContactForEdit(contact);
            }

            this.showModal();
        },
    },

    methods: {
        showModal () {
            this.$refs.modal.show();
        },

        closeModal () {
            this.$refs.modal.hide();
            this.form.reset();
            this.contact = null;
        },

        addFile () {
            this.form.photo = this.$refs.file.files[0];
        },

        async submit () {
            try {
                this.loading = true;

                if (! this.form.photo) {
                    delete this.form.photo;
                }

                if (this.isEdit) {
                    this.form._method = 'PATCH';
                }

                await this.form.post(this.actionRoute);

                this.closeModal();

                OSPEvent.$emit('contacts-updated', {});
            } catch (errors) {
                console.error(errors);
            } finally {
                this.loading = false;
            }
        },

        setContactForEdit (contact) {
            this.contact = _.clone(contact);

            this.form.first_name = contact.first_name;
            this.form.last_name = contact.last_name;
            this.form.title = contact.title;
            this.form.email = contact.email;
            this.form.phone = contact.phone;
            this.form.phone_ext = contact.phone_ext;
            this.form.phone_2 = contact.phone_2;
            this.form.phone_2_ext = contact.phone_2_ext;
            this.form.contactable_type = contact.contactable_type;
            this.form.contactable_id = contact.contactable_id;
            this.form.notes = contact.notes;
            this.form.primary = contact.primary;
        },
    },
};
</script>

<style>
.trumbowyg-box.trumbowyg-editor-visible {
  min-height: 100px;
}

.trumbowyg-editor {
  min-height: 100px;
}
</style>
